// Admin moderation of article comments.
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/modules/growing-circle/lib/api";
import { Button } from "@/components/ui/button";

const STATUS_LABEL = { pending: "In attesa", approved: "Approvato", hidden: "Nascosto", deleted: "Eliminato" };

export default function AdminArticleComments() {
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const load = async () => { try { const { data } = await api.get(`/admin/articles/${id}/comments`); setItems(data); } catch {} };
  useEffect(() => { load(); }, [id]);
  const act = async (cid, action) => {
    if (action === "delete") { await api.delete(`/admin/comments/${cid}`); }
    else { await api.post(`/admin/comments/${cid}/${action}`); }
    load();
  };
  return (
    <div data-testid="admin-comments">
      <h1 className="font-heading text-3xl tracking-tight mb-6">Commenti</h1>
      <ul className="space-y-3">
        {items.map((c) => (
          <li key={c.id} className="bg-card border border-border rounded-xl p-4" data-testid={`mod-comment-${c.id}`}>
            <div className="flex items-baseline justify-between">
              <span className="text-sm font-medium">{c.user_name}</span>
              <span className="text-xs text-muted-foreground">{c.status && STATUS_LABEL[c.status]}</span>
            </div>
            <p className="text-sm whitespace-pre-wrap mt-2">{c.body}</p>
            <div className="flex gap-2 mt-3">
              {c.status !== "approved" && <Button size="sm" onClick={() => act(c.id, "approve")} data-testid={`approve-${c.id}`}>Approva</Button>}
              {c.status !== "hidden" && <Button size="sm" variant="outline" onClick={() => act(c.id, "hide")} data-testid={`hide-${c.id}`}>Nascondi</Button>}
              <Button size="sm" variant="ghost" onClick={() => act(c.id, "delete")} data-testid={`delete-${c.id}`}>Elimina</Button>
            </div>
          </li>
        ))}
        {items.length === 0 && <li className="text-muted-foreground text-sm">Nessun commento.</li>}
      </ul>
    </div>
  );
}
